import React, {FC} from 'react'
import {DocumentPartForm, DocumentTemplateFormData} from './documentTemplateForm'
import {DocumentTemplatePartForm} from './DocumentTemplatePartForm'
import {ViewMode} from './useTemplateDataEditor'

interface Props {
    initialFormData: DocumentTemplateFormData
    formData: DocumentTemplateFormData
    onTitleChange: (title: string) => void
    onPartChange: (index: number, part: DocumentPartForm) => void
    onAddPart: () => void
    onRemovePart: (index: number) => void
    onMovePart: (from: number, to: number) => void
    onConfirm: () => void
    onCancel: () => void
    viewMode: ViewMode
}

export const DocumentTemplateContent: FC<Props> = ({
    initialFormData,
    formData,
    onTitleChange,
    onPartChange,
    onAddPart,
    onRemovePart,
    onMovePart,
    onConfirm,
    onCancel,
    viewMode,
}) => {
    if (viewMode === 'formEdit') {
        return (
            <div className="document-template-content">
                <div className="template-data-form-field">
                    <label className="template-data-form-label">Title</label>
                    <input
                        type="text"
                        className="template-data-form-input"
                        value={formData.title}
                        onChange={(e) => onTitleChange(e.target.value)}
                    />
                </div>

                {formData.parts.length === 0 ? (
                    <div className="document-template-content__empty">
                        <span className="document-template-content__empty-text">No parts</span>
                        <button type="button" className="document-template-content__add-part" onClick={onAddPart}>
                            Add part
                        </button>
                    </div>
                ) : (
                    <div className="document-template-content__parts">
                        {formData.parts.map((part, index) => (
                            <DocumentTemplatePartForm
                                key={part.id}
                                part={part}
                                index={index}
                                onChange={(updated) => onPartChange(index, updated)}
                                onRemove={() => onRemovePart(index)}
                                onMoveUp={index > 0 ? () => onMovePart(index, index - 1) : undefined}
                                onMoveDown={index < formData.parts.length - 1 ? () => onMovePart(index, index + 1) : undefined}
                                onConfirm={onConfirm}
                                onCancel={onCancel}
                            />
                        ))}
                        <button type="button" className="document-template-content__add-part" onClick={onAddPart}>
                            Add part
                        </button>
                    </div>
                )}
            </div>
        )
    }

    return (
        <div className="template-data-form">
            <div className="template-data-form-field">
                <label className="template-data-form-label">Title</label>
                <div className="template-data-form-value">{initialFormData.title}</div>
            </div>

            {initialFormData.parts.length === 0 ? (
                <div className="template-data-form-field">
                    <label className="template-data-form-label">Parts</label>
                    <div className="template-data-form-value">No parts</div>
                </div>
            ) : (
                initialFormData.parts.map((part) => (
                    <div key={part.id} className="document-template-content__view-part">
                        <div className="template-data-form-field">
                            <label className="template-data-form-label">Type</label>
                            <div className="template-data-form-value">{part.partType}</div>
                        </div>
                        <div className="template-data-form-field">
                            <label className="template-data-form-label">Header</label>
                            <div className="template-data-form-value">{part.partHeader}</div>
                        </div>
                        <div className="template-data-form-field template-data-form-field-content">
                            <label className="template-data-form-label">Content</label>
                            <div className="template-data-form-value template-data-form-value-multiline">{part.partContent}</div>
                        </div>
                    </div>
                ))
            )}
        </div>
    )
}
